import { CheckoutSessionProvider } from "@circle-react/components/Paywalls/Checkout/contexts/CheckoutSessionContext";
import { useCheckoutSessionRouteParams } from "@circle-react/components/Paywalls/CheckoutWithSession/hooks/useCheckoutSessionRouteParams";
import { ViewAsMainOfferPage } from "@circle-react/components/Paywalls/CheckoutWithSession/pages/ViewAsMainOfferPage";
import { MainOfferRoute } from "@circle-react/components/Paywalls/CheckoutWithSession/routes/MainOfferRoute";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { rootRoute } from "@circle-react/routes/PaywallCheckout/tanstack_routes/__root";
import { createRoute } from "@tanstack/react-router";

export const mainOfferRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/checkout/$checkoutPath",
  component: MainOffer,
});

function MainOffer() {
  const { paywallId } = mainOfferRoute.useRouteContext();
  const { paymentValidationParams, sessionId, stepId } =
    useCheckoutSessionRouteParams();
  const { isViewOnlyMasquerading } = usePunditUserContext();

  if (isViewOnlyMasquerading) {
    return <ViewAsMainOfferPage paywallId={paywallId} />;
  }

  return (
    <CheckoutSessionProvider
      paywallId={paywallId}
      sessionId={sessionId}
      stepId={stepId}
      paymentValidationParams={paymentValidationParams}
    >
      <MainOfferRoute />
    </CheckoutSessionProvider>
  );
}
